// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__26nwV","unreadBadge":"styles_unreadBadge__1C6O0","modalContent":"styles_modalContent__2uZrg","modal":"styles_modal__1qM7j"};